import { BookmarkablePage, FullPagePanel, useNavigation } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { ConsoleContext } from "../../console/ConsoleContext";
import { PageId, PageRegistrationConfig, RECENT_RESOURCES_ROUTE } from "../../constants/pluginConstants";
import { RecentList } from "./RecentList";

const registrationIds = PageRegistrationConfig[PageId.RECENT_RESOURCES].map(config => config.key);

export const RecentListPage = (): JSX.Element => {
  const { back, navigateToSelf } = useNavigation(ConsoleContext);

  React.useEffect(() => {
    // In case page was navigated to directly by entring its URL in the browser
    navigateToSelf(RECENT_RESOURCES_ROUTE, registrationIds[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BookmarkablePage
      appContext={ConsoleContext}
      registrationIds={registrationIds}
      title={Messages.listRecent.titles.short()}
    >
      <FullPagePanel
        title={Messages.listRecent.titles.long()}
        onClose={back}
        isOpen
      >
        <RecentList />
      </FullPagePanel>
    </BookmarkablePage>
  );
};
